module.exports = __webpack_public_path__ + "static/media/student.1df86bff.svg";